module.exports = __webpack_public_path__ + "static/img/IMG_20160930_134603.922e73a5.jpg";